import BzbsProfile from '@/service/BzbsProfile.js';

export default function Register() {
    this.objRegister = null;
    this.objRegisterAddress = null;
    this.objOtherInfo = null;

    this.genRegisterModel = function() {
        return {
            strUsername: '',
            strPassword: '',
            strConfirmPassword: '',
            strFirstname: '',
            strLastname: '',
            strEmail: '',
            strContactNumber: '',
            strBirthDate: '',
            strNationalID: '',
            strGender: '',
        };
    };

    this.genRegisterAddressModel = function() {
        return {
            strAddress: '',
            strZipcode: '',
            strProvinceCode: '',
            strProvinceName: '',
            strDistrictCode: '',
            strDistrictName: '',
            strSubDistrictCode: '',
            strSubDistrictName: '',
            strLatitude: '',
            strLongitude: '',
        };
    };

    this.genRegisterOtherInfoModel = function() {
        return {
            strInfo: '',
            strCustomInfo: '',
        }
    };

    this.requestOTP = function() {

    };

    this.registerSetup = function(registerModel) {
        this.objRegister = registerModel;
        return this;
    };
    this.registerAddressSetup = function(registerAddressModel) {
        this.objRegisterAddress = registerAddressModel;
        return this;
    };
    this.registerOtherInfoSetup = function(registerOtherInfoModel) {
        this.objOtherInfo = registerOtherInfoModel;
        return this;
    };

    this.sendRegister = function(strToken,objSendRegister) {
        return new Promise((resolve, reject) => {
            if (!strToken) {
                // resolve(null);
                reject(null);
            } else {

                BzbsProfile.registerChanel(strToken,objSendRegister).then((response) => {
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });
            }
        });
    };

    this.authStart = function(strToken) {
        return new Promise((resolve, reject) => {
            if (!strToken) {
                resolve(null);
            } else {

                BzbsProfile.authstartChanel(strToken).then((response) => {
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });
            }
        });
    };
}
